import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import Wrapper from '../../elements/wrapper';
import SVGContainer from './svg-container';
import PaletteSelector from './palette-selector';
import SavedPalettes from './saved-palettes';
import CustomizerProductVariants from './customizer-product-variants';

import X from '../../../images/icons/x.inline.svg';

const ProductCustomizerContainer = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 5500;
    background-color: #fff;

    .top-bar-wrapper {
        max-width: 100vw;
        background-color: #f2f0eb;

        .inner-wrap {
            display: flex;
            align-items: center;
            max-width: 100vw;
            .product-title-container {
                flex: 2;
                padding-left: 5vw;
                h2 {
                    margin: 0;
                    font-family: neue-kabel, sans-serif;
                    font-weight: 800;
                    font-size: 1.5rem;
                    span {
                        font-size: 0.8rem;
                        margin-right: 10px;
                        font-family: sofia-pro, sans-serif;
                        position: relative;
                        top: -3px;
                    }
                }
            }

            .close-container {
                flex: 1;
                text-align: right;
                button {
                    padding: 25px;
                    line-height: 1;
                    background-color: #3d3b0f;
                    border: none;
                    svg {
                        stroke: #fff;
                    }
                }
            }
        }
    }

    .st0 {
        fill: red;
    }
    .st0 {
        fill: white;
    }
    .st0 {
        fill: blue;
    }

    .customizer-wrapper {
        padding-top: 40px;
        display: flex;
        > * {
            flex: 0 0 33.33%;
        }

        .col {
            padding-right: 30px;
            &:last-child {
                padding-right: 0px;
            }
            > .title-container {
                border-top: 2px solid #f74d33;
                padding-top: 20px;
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                h3 {
                    font-size: 1rem;
                    color: #f74d33;
                    margin-right: 30px;
                    margin-bottom: 0px;
                }

                .link {
                    a {
                        font-size: 0.7rem;
                        color: #702716;

                        &:hover {
                            opacity: 0.7;
                        }
                    }
                    button {
                        font-size: 0.7rem;
                        color: #702716;
                        padding: 0;
                        border: none;
                        background-color: transparent;
                        text-decoration: underline;
                        &:hover {
                            opacity: 0.7;
                        }
                    }
                }
            }

            &.col-left {
                position: relative;
                overflow: hidden;
            }
            &.col-center {
            }
        }
    }
`;

const ProductCustomizer = ({
    product,
    isCustomizerOpen,
    setIsCustomizerOpen,
}) => {
    const { title } = product || {};
    const [currentPalette, setCurrentPalette] = useState({
        primary_color: {
            name: '',
            code: '',
        },
        secondary_color: {
            name: '',
            code: '',
        },
        accent_1: {
            name: '',
            code: '',
        },
        accent_2: {
            name: '',
            code: '',
        },
        accent_3: {
            name: '',
            code: '',
        },
        accent_4: {
            name: '',
            code: '',
        },
    });
    const [currentSVG, setCurrentSVG] = useState(0);
    const isBrowser = typeof window != 'undefined';
    function switchView() {
        if (currentSVG === 0) {
            setCurrentSVG(1);
        } else {
            setCurrentSVG(0);
        }
    }

    function handleCloseCustomizer() {
        setIsCustomizerOpen(false);
        if (isBrowser) {
            window.history.pushState(
                'page2',
                'Title',
                window.location.href.replace(window.location.search, '')
            );
        }
    }

    return (
        <ProductCustomizerContainer
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
                open: { transform: 'translate3d(0, 0%, 0)' },
                collapsed: { transform: 'translate3d(0, 100%, 0)' },
            }}
            transition={{
                duration: 0.5,
            }}
        >
            <Wrapper className="top-bar-wrapper">
                <Wrapper className="inner-wrap">
                    <div className="product-title-container">
                        <h2>
                            <span>Currently Customizing: </span>
                            {title}
                        </h2>
                    </div>
                    <div className="close-container">
                        <button onClick={() => handleCloseCustomizer()}>
                            <X />
                        </button>
                    </div>
                </Wrapper>
            </Wrapper>
            <Wrapper className="customizer-wrapper">
                <div className="col col-left">
                    <div className="title-container">
                        <h3>Select 3 Colors</h3>{' '}
                        <div className="link">
                            <a href="#">Color Matching Guide</a>
                        </div>
                    </div>

                    <PaletteSelector
                        setCurrentPalette={setCurrentPalette}
                        currentPalette={currentPalette}
                    />
                    <SavedPalettes
                        setCurrentPalette={setCurrentPalette}
                        currentPalette={currentPalette}
                    />
                </div>
                <div className="col col-center">
                    <div className="title-container">
                        <h3>Preview Your Design</h3>{' '}
                        <div className="link">
                            <button onClick={() => switchView()}>
                                Switch View
                            </button>
                        </div>
                    </div>
                    <SVGContainer
                        currentSVG={currentSVG}
                        currentPalette={currentPalette}
                    />
                </div>
                <div className="col col-right">
                    <div className="title-container">
                        <h3>Pick Size & Quantity</h3>{' '}
                        <div className="link"></div>
                    </div>
                    <CustomizerProductVariants
                        currentPalette={currentPalette}
                        product={product}
                    />
                </div>
            </Wrapper>
        </ProductCustomizerContainer>
    );
};

export default ProductCustomizer;
